import { Amplify } from 'aws-amplify';

// Only configure Amplify if Cognito credentials are provided
// This allows dev bypass mode to work without Cognito
const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
const userPoolClientId = import.meta.env.VITE_COGNITO_APP_CLIENT_ID;

if (userPoolId && userPoolClientId) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
      }
    }
  });
} else if (import.meta.env.VITE_DEV_BYPASS_AUTH !== 'true') {
  console.warn('[Amplify] Missing Cognito configuration. Set VITE_COGNITO_USER_POOL_ID and VITE_COGNITO_APP_CLIENT_ID, or enable VITE_DEV_BYPASS_AUTH=true for local development.');
}

export default Amplify;
